<div>
  <app-async-initialization-loading-overlay></app-async-initialization-loading-overlay>
  <router-outlet></router-outlet>
  <p-toast position="bottom-left"></p-toast>
  <p-confirmDialog [style]="{ maxWidth: '45rem' }"></p-confirmDialog>
  <app-loading-dialog></app-loading-dialog>
</div>
